import { render } from "./UserDataBase.vue?vue&type=template&id=b8c48f8c&scoped=true"
import script from "./UserDataBase.vue?vue&type=script&lang=js"
export * from "./UserDataBase.vue?vue&type=script&lang=js"

import "./UserDataBase.vue?vue&type=style&index=0&id=b8c48f8c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8c48f8c"]])

export default __exports__